<template>
    <div class="">
        <el-table
            :data="items"
            stripe
            border
            fit
            class="domain-table"
            :show-overflow-tooltip="false"
            table-layout="auto"
        >
            <template slot="empty">
                <div v-if="loading" class="loading-body">
                    <i class="el-icon-loading"></i>
                    <span>Đang tải...</span>
                </div>
                <div v-else class="empty-body">
                    <span>Không có dữ liệu</span>
                </div>
            </template>
            <el-table-column label="Thời gian" min-width="110">
                <template slot-scope="{ row }">
                    <span>Quý {{convertToRoman(row.quarter)}}/{{row.year}}</span>
                </template>
            </el-table-column>
            <el-table-column label="Họ tên" min-width="200">
                <template slot-scope="{ row }">
                    <span>{{row.user.name}}</span>
                </template>
            </el-table-column>
            <el-table-column label="Mã NS" min-width="80">
                <template slot-scope="{ row }">
                    <span>{{row.user?.id + 100000 ?? ''}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="position" label="Vị trí" min-width="140">
                <template slot-scope="{ row }">
                    <span>{{row.user?.profile?.account_type?.name}}</span>
                </template>
            </el-table-column>
            <el-table-column label="Level hiện tại" min-width="150">
                <template slot-scope="{ row }">
                    <span>{{row.current_level.level}}</span>
                </template>
            </el-table-column>
            <el-table-column min-width="220" label="Team">
                <template slot-scope="{ row }">
                    <span>{{row.department.name}}</span>
                </template>
            </el-table-column>

            <el-table-column min-width="180">
                <template slot="header">
                    <el-tooltip
                        effect="light"
                        placement="top"
                        content="Tiêu chí 1 - KRAs 3 tháng trong quý đều đạt 100% KPIs"
                    >
                        <span>Tiêu chí 1: Chỉ số</span>
                    </el-tooltip>
                </template>
                <template slot-scope="{ row }">
                   <span :class="row.aprrove_type ? 'text-success' : 'text-danger'">
                          {{ row.aprrove_type ? 'Đạt' : 'Không đạt' }}
                   </span>
                </template>
            </el-table-column>
            <el-table-column min-width="180" label="Tiêu chí 2: Exp">
                <template slot-scope="{ row }">
                    <span>{{row?.total_exp ?? 0}} / {{row?.requested_level?.criteria_2 ?? 0}}</span>
                </template>
            </el-table-column>

            <el-table-column label="Kết quả" min-width="170">
                <template slot-scope="{ row }">
                    <div class="w-100" style="font-weight: 700" :class="expectedDefineColor[row.approve_type]">
                        {{ expectedDefineText[row.approve_type] }}
                        <i style="font-weight:800" :class="expectedDefineIcon[row.approve_type]"></i>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="Duyệt level quản trị" min-width="180">
                <template slot-scope="{ row }">
                    <el-button
                        v-if="getStatus(row.status)"
                        size="mini"
                        :style="{ backgroundColor: getStatus(row.status).color, color: getStatus(row.status).text }"
                        :type="getStatus(row.status).type"
                        class="btn-approve-level w-100"
                    >
                        {{ getStatus(row.status).label }}
                    </el-button>
                </template>
            </el-table-column>

            <el-table-column label="Level quản trị mới" min-width="190">
                <template slot-scope="{ row }">
                    <el-tooltip effect="light" placement="top">
                        <div v-if="getPointNeeded(row)" slot="content">
                            Mục tiêu của bạn rất gần rồi 😍<br>
                            Bạn cần đạt <b>{{ getPointNeeded(row) }}</b> điểm
                        </div>
                        <div v-else slot="content">
                                Bạn đã đủ điểm để đạt level tiếp theo 😍
                        </div>
                        <span>{{ row.requested_level?.level }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
export default {
    name: 'AdminReviewTable',
    components: {

    },
    props: {
        items: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
    },
    data() {
        return {
            statusMap: {
                1: { label: 'Duyệt', color: '#7ED957', type: '', text:'#FFFFFF' },
                2: { label: 'Chờ duyệt', color: '', type: 'info', text:'#7351B8' },
                3: { label: 'Không duyệt', color: '', type: 'danger', text:'#FFFFFF' },
            },
            expectedDefineIcon: { 0:'', 1:'el-icon-top', 2:'el-icon-bottom', 3:'fas fa-square' },
            expectedDefineText: { 0:'', 1:'Tăng Level',  2:'Giảm Level', 3:'Giữ Nguyên Level' },
            expectedDefineColor:{ 0:'', 1:'text-success', 2:'text-danger', 3:'text-warning' },
        };
    },
    methods: {
        convertToRoman(num) {
            const romanNumerals = {
                1: 'I',
                2: 'II', 
                3: 'III',
                4: 'IV'
            };
            return romanNumerals[num] || num;
        },
        getPointNeeded(item) {
            const kra_score = item.kra_score ?? 0;
            const meeting_points = item.meeting_points ?? 0;
            const exp_points = item.exp_points ?? 0;
            const sum = parseInt(kra_score)+parseInt(meeting_points)+parseInt(exp_points)
            const denominator = parseInt(item.requested_level.score) ?? 0;

            if(denominator - sum > 0) {
                return denominator - sum;
            }
            return 0;
        },

        getStatus(status) {
            return this.statusMap[status];
        },
    }
};
</script>


<style style lang="scss" scoped>
/* Harmonize table style with TeamleadProgressTable */
/deep/ .domain-table .el-table__header th,
/deep/ .domain-table .el-table__body td,
/deep/ .domain-table .el-table__header th .cell,
/deep/ .domain-table .el-table__body td .cell {
    white-space: normal !important;
    word-break: keep-all !important;
    overflow: visible !important;
    max-width: none !important;
    height: auto !important;
    text-align: center !important;
    box-sizing: border-box !important;
}

/deep/ .domain-table .el-table__header th {
    background: #4d1eab !important;
    color: #fff !important;
    border-color: #4d1eab !important;
    line-height: 1.4 !important;
    padding: 16px 8px !important;
    height: 80px !important;
}

/deep/ .domain-table .el-table__body td {
    line-height: 1.3 !important;
    padding: 8px 4px !important;
    height: auto !important;
}

/deep/ .domain-table .el-table__body tr {
    height: 80px !important;
}

/* Force keep-all word-break with higher specificity to override other scoped rules */
/deep/ .domain-table .el-table__body td .cell,
/deep/ .domain-table .el-table__body td .cell * {
    word-break: keep-all !important;
    white-space: normal !important;
}

.loading-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    color: #606266;
    
    i {
        font-size: 24px;
        margin-bottom: 10px;
        animation: rotating 2s linear infinite;
    }
    
    span {
        font-size: 14px;
    }
}

.empty-body {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    color: #909399;
    
    span {
        font-size: 14px;
    }
}

@keyframes rotating {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

</style>
